<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">THE BORDERS</h1>
<h3 class="subtitle"><i>A History of the Borders<br/> from Earliest Times</i></h3>
<p class="star"><span class="center">*********</span></p>
<h3 class="auth">Alistair Moffat</h3>
<p class="logo"><img alt="Logo Image" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?78a7d954